import { Rights } from '@dokucoach/common-types';
import { useContextAuthManager } from 'components/AuthManager';
import { useContextBaseDataAside } from 'components/Layout/components/BaseDataAside/context';
import { BaseDataForm, BaseDataSubmenu } from 'components/Layout/components/BaseDataAside/submenu';
import routePaths from 'constants/route-paths';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { getPath } from 'utils/path';
import { FormListButton } from '../../AsideMenuList/style';

type Props = {
  menuItems: BaseDataSubmenu[];
  entityId: string;
  routePath: string;
  isInactive?: boolean;
  isDeleted?: boolean;
  isApplicant?: boolean;
};

const EntitySubMenu = ({
  menuItems,
  entityId,
  routePath,
  isInactive = false,
  isDeleted = false,
  isApplicant = false,
}: Props) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { user, hasOnePermission } = useContextAuthManager();
  const { activeMenu, setActiveMenu, activeUser, setActiveUser } = useContextBaseDataAside();

  const isActive = (submenu: BaseDataSubmenu): boolean => {
    return activeUser === entityId && activeMenu === submenu.id;
  };

  const onClick = (e: BaseDataSubmenu) => {
    setActiveMenu(e.id);
    setActiveUser(entityId);
    const selectedFilter = isApplicant
      ? routePaths.APPLICANT
      : isDeleted
      ? routePaths.DELETED
      : isInactive
      ? routePaths.INACTIVE
      : '';
    history.push(getPath([routePath, e.path, selectedFilter], { entityId }));
  };

  const isEnabled =
    user?.nursingHome.license.invoicingEnabledFrom &&
    hasOnePermission([
      Rights.ADMINISTRATION_AND_INVOICING.INVOICE.READ,
      Rights.ADMINISTRATION_AND_INVOICING.INVOICE.WRITE,
    ]);

  return (
    <div className="menu-submenu has-collapse">
      <ul className="menu-subnav">
        {menuItems.map(
          (submenu) =>
            ((submenu.id === BaseDataForm.INVOICING && isEnabled) ||
              submenu.id !== BaseDataForm.INVOICING) && (
              <li
                key={submenu.id}
                className={`menu-item pl-5 ${isActive(submenu) && 'menu-item-active'}`}
              >
                <FormListButton className="menu-link my-1" onClick={() => onClick(submenu)}>
                  <span
                    className={`menu-text ${isActive(submenu) && 'active'}`}
                    data-user-id={entityId}
                  >
                    {t(submenu.label)}
                  </span>
                </FormListButton>
              </li>
            ),
        )}
      </ul>
    </div>
  );
};

export default EntitySubMenu;
